import React, { useState } from "react";
import axios from "axios";
import "../assets/expo_landing_page.css";
import rp from '../assets/imgs/RiverParadise/rp3.png';

export default function Rp() {

    const [form, setForm] = useState({
        name: "",
        mobile: "",
        city: "",
        budget: "",
        project: "River Paradise – Mulshi" // ✅ FIXED PROJECT
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (form.mobile.length !== 10) {
            alert("Enter valid mobile number");
            return;
        }

        setLoading(true);

        try {
            const res = await axios.post(
                "https://samriddhidevelopers.in/backend/expo_lead.php",
                form,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (res.data.status === "success") {

                const message = `Hi, I am ${form.name}. Interested in River Paradise. Budget: ${form.budget}. I want details.`;

                const encoded = encodeURIComponent(message);

                setTimeout(() => {
                    window.location.href = `https://wa.me/919766010099?text=${encoded}`;
                }, 800);

            } else {
                alert("Failed to save lead");
            }

        } catch (err) {
            console.error(err);
            alert("Server error");
        }

        setLoading(false);
    };

    return (
        <div className="expo-page">

            {/* HERO */}
            <section className="expo-hero" style={{ backgroundImage: `url(${rp})` }}>
                <div className="expo-overlay">
                    <h1 className="expo-heading">
                        River Paradise @ Mulshi
                    </h1>

                    <p className="expo-sub">
                        Waterfront Living Meets Luxury Investment
                    </p>

                    <button
                        className="expo-primary-btn"
                        onClick={() =>
                            document.getElementById("form").scrollIntoView({ behavior: "smooth" })
                        }
                    >
                        Get Details
                    </button>
                </div>
            </section>

            {/* HIGHLIGHTS */}
            <section className="expo-projects">
                <h2 className="section-title">Project Highlights</h2>

                <div className="expo-grid">
                    <div className="expo-card">River Touch Plots 🌊</div>
                    <div className="expo-card">Boating Experience 🚤</div>
                    <div className="expo-card">Organic Farming 🌱</div>
                    <div className="expo-card">Internal Roads 🛣️</div>
                </div>
            </section>

            {/* FORM */}
            <section id="form" className="expo-form-section">
                <h2 className="expo-section-title-white">
                    Get Price & Site Visit Details
                </h2>

                <form className="expo-form" onSubmit={handleSubmit}>

                    <input name="name" placeholder="Your Name" onChange={handleChange} required />
                    <input name="mobile" placeholder="Mobile Number" onChange={handleChange} required />
                    <input name="city" placeholder="City" onChange={handleChange} required />

                    <select name="budget" onChange={handleChange} required>
                        <option value="">Select Budget</option>
                        <option>30–50L</option>
                        <option>50–80L</option>
                        <option>80L+</option>
                    </select>

                    <button type="submit" className="expo-primary-btn" disabled={loading}>
                        {loading ? "Submitting..." : "Get Details on WhatsApp"}
                    </button>
                </form>
            </section>

        </div>
    );
}